import RollbarService from 'services/RollbarService';

export default {
  install(Vue) {
    Vue.prototype.$rollbar = RollbarService;
  },
};
